import { ZodError } from 'zod'
import { isAxiosError } from 'axios'
import { MutationCache, QueryCache } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { toastSentryError } from '@/lib/appErrorSentry'

const excludeStatusCodes = [401]

export const trackingSentryMutation = () =>
  new MutationCache({
    onError: (error, variables, context, mutation) => {
      let id = null
      if (error instanceof ZodError) {
        id = Sentry.captureException(error)
        toastSentryError(id)
      }

      if (
        isAxiosError(error) &&
        error.response?.status &&
        error.response.status >= 400 &&
        !excludeStatusCodes.includes(error.response.status)
      ) {
        id = Sentry.captureException(error, {
          tags: {
            type: 'react-query-mutation',
            mutationKey: mutation.options.mutationKey?.join(',')
          },
          extra: {
            variables,
            context,
            meta: mutation.options.meta
          }
        })

        if (error.response.status >= 500) {
          toastSentryError(id)
        }
      }

      if (import.meta.env.DEV) {
        console.error(error)
      }
    }
  })

export const trackingSentryQueries = () =>
  new QueryCache({
    onError: (error, query) => {
      let id = null
      if (error instanceof ZodError) {
        id = Sentry.captureException(error)
        toastSentryError(id)
      }

      if (
        isAxiosError(error) &&
        error.response?.status &&
        error.response.status >= 400 &&
        !excludeStatusCodes.includes(error.response.status)
      ) {
        id = Sentry.captureException(error, {
          tags: {
            type: 'react-query',
            queryKey: query.options.queryKey?.join(',')
          }
        })

        if (error.response.status >= 500) {
          toastSentryError(id)
        }
      }

      if (import.meta.env.DEV) {
        console.error(error)
      }
    }
  })
